/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */
/*
  Styles in this file are based on
  packages/editor/editor-core/src/plugins/media/styles.ts
*/

export const resizerItemClassName = 'resizer-item';
export const resizerHoverZoneClassName = 'resizer-hover-zone';
export const resizerExtendedZone = 'resizer-is-extended';

export const resizerHandleClassName = 'resizer-handle';
export const resizerHandleTrackClassName: 'resizer-handle-track' = `${resizerHandleClassName}-track`;
export const resizerHandleThumbClassName: 'resizer-handle-thumb' = `${resizerHandleClassName}-thumb`;
export const resizerDangerClassName: 'resizer-handle-danger' = `${resizerHandleClassName}-danger`;

export const handleWrapperClass = 'resizer-handle-wrapper';

export const resizerHandleThumbWidth = 3;
export const resizerHandleZIndex = 1;
